// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".marked {\n  margin: 0;\n  padding: 0;\n  text-align: left;\n  word-break: break-word;\n}\n.marked a {\n  word-wrap: anywhere;\n  word-break: break-all;\n  overflow-wrap: break-word;\n}\n.marked img {\n  display: block;\n  max-width: 100%;\n  height: auto;\n}", ""]);
// Exports
module.exports = exports;
